import React, { useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import {FaBriefcase, FaPaperPlane } from 'react-icons/fa';
import { Container, Row, Col, Form, Button, Card, Spinner, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/admission/admission.css'; // You'll need to create this file for additional styling

const firebaseConfig = {
  apiKey: "AIzaSyAo8JAiRJUyz6ArJCHOCwEqHQEmfbWgtgA",
  authDomain: "olewin-academy.firebaseapp.com",
  projectId: "olewin-academy",
  storageBucket: "olewin-academy.appspot.com",
  messagingSenderId: "622543323365",
  appId: "1:622543323365:web:9a3e28d5c63850d60e940c",
  measurementId: "G-09WHHRMJRC"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const AdmissionForm = () => {
  // List of all courses offered
  const courses = [
    { id: 'iit-main', name: 'IIT-JEE ( Mains)' },
    { id: 'iit-ad', name: 'IIT-JEE (Advance)' },
    { id: 'iit-jee', name: 'IIT-JEE (Mains & Advance)' },
    { id: 'neet-ug', name: 'NEET - UG (For MBBS)' },
    { id: 'neet-pg', name: 'NEET - PG ((Dr.) MS/MD Specialization)' },
    { id: 'iit-jam', name: 'IIT-JAM' },
    { id: 'gate-sci', name: 'GATE - Science ' },
    { id: 'gate-engg', name: 'GATE - Engineering' },
    { id: 'data-scientist', name: 'Data Scientist' },
    { id: 'quantum-computing-engineer', name: 'Quantum Computing Engineer' },
    { id: 'geo-tech-engineer', name: 'GeoApplication Engineer' },
    { id: 'geo-scientist', name: 'GeoScientist' },
    { id: 'geo-ai', name: 'GeoEngineer Technical ' },
    { id: 'energy-tech', name: 'Energy Sector Technological Engineer' },
    { id: 'environment-science', name: 'Environment Science Technology Program ' },
    { id: 'fullstack-ai-developer', name: 'Full Stack AI-App Developer' },
    { id: 'ai-agent-engineer', name: 'Full Stack Agent/RAG/Edge/Gen-AI Engineer' },
    { id: 'business-analyst', name: 'Business Analyst' },
    { id: 'data-analyst', name: 'Data Analyst' },
    { id: 'web-developer', name: ' Web 3.0 Developer' },
    { id: 'software-developer', name: 'Senior Software Developer' },
    { id: 'net-developer', name: '.NET Developer' },
    { id: 'java-developer', name: 'Full Stack Java Developer' },
    { id: 'ai-agent-developer', name: 'AI Agent/LLM Developer' },
    { id: 'prompt-engineer', name: 'Prompt Engineer' },
    { id: 'ai-ml-engineer', name: 'AI and ML Engineer' },
    { id: 'cloud-engineer', name: 'Cloud Engineer' },
    { id: 'cloud-architect', name: 'Cloud Architect(multi-cloud)' },
    { id: 'devops-engineer', name: 'DevOps Engineer' },
    { id: 'blockchain-developer', name: 'Blockchain Developer' },
    { id: 'cloud-computing', name: 'Cloud Computing Specialist' },
    { id: 'iot-engineer', name: 'IoT Engineer ( Enterprise)' },
    { id: 'robotics-engineer', name: 'Robotics Engineer' },
    { id: 'mobile-app-developer', name: 'Mobile App Developer' },
    { id: 'big-data-engineer', name: 'Big Data Engineer' },
    { id: 'pmp', name: 'Project Management Professional (PMP)' },
    { id: 'gre', name: 'ETS/GRE' },
    { id: 'toefl', name: 'TOEFL' },
    { id: 'ielts', name: 'IELTS' },
    { id: 'gmat', name: 'GMAT' },
    { id: 'mcat', name: 'MCAT' },
    { id: 'fmge', name: 'FMGE - PG - Medical' },
    { id: 'sat', name: 'SAT' },
    { id: 'pte', name: 'PTE' },
  
    { id: 'other', name: 'Looking for Other Course' },

  ];

  // Course durations
  const durations = [
    '3 months', '6 months', '9 months', '1 year', '1.5 years', '2 years'
  ];

  // Form state
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    graduationYear: '',
    selectedCourse: '',
    courseDuration: '',
    internshipInterest: false,
    additionalNotes: '',
    college:'',
    education:''
  });

  // Form submission state
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, variant: '', message: '' });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // Form submission handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ show: false, variant: '', message: '' });

    try {
      // Validate form
      if (!formData.fullName || !formData.email || !formData.phone || !formData.selectedCourse || !formData.courseDuration) {
        throw new Error('Please fill all required fields');
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        throw new Error('Please enter a valid email address');
      }

     // Phone validation
const phoneRegex = /^\d{10,11}$/;
if (!phoneRegex.test(formData.phone)) {
  throw new Error('Please enter a valid phone number (10-11 digits)');
}

// Form validation - add graduationYear
if (!formData.fullName || !formData.email || !formData.phone || 
    !formData.selectedCourse || !formData.courseDuration || !formData.graduationYear) {
  throw new Error('Please fill all required fields');
}
      // Add timestamp
      const submissionData = {
        ...formData,
        submittedAt: new Date().toISOString()
      };

      // Save to Firebase
      await addDoc(collection(db, "admissions"), submissionData);
      
      // Success alert
      setAlert({
        show: true, 
        variant: 'success', 
        message: 'Your application has been submitted successfully! We will contact you soon.'
      });
      
      // Reset form
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        graduationYear: '',
        selectedCourse: '',
        courseDuration: '',
        internshipInterest: false,
        additionalNotes: '',
        college:'',
        education:''
      });
      
    } catch (error) {
      // Error alert
      setAlert({
        show: true, 
        variant: 'danger', 
        message: error.message || 'An error occurred. Please try again.'
      });
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false);
      
      // Scroll to the top to show the alert
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Get current year for graduation year dropdown
  const currentYear = new Date().getFullYear();
  const yearOptions = [];
  for (let i = currentYear - 15; i <= currentYear + 5; i++) {
    yearOptions.push(i);
  }

  return (
    <div className="admission-page my-2 py-2">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={9}>
            {alert.show && (
              <Alert 
                variant={alert.variant} 
                onClose={() => setAlert({...alert, show: false})} 
                dismissible
                className="mt-4 alert-animated"
              >
                {alert.message}
              </Alert>
            )}
            
            <Card className="admission-card my-5 py-2">
              <div className="card-header-custom">
                <h2 className="text-center mb-2 display-3 ">Admission Application</h2>
                <p className="text-center text-dark fw-bold mb-0">Join our tech training programs and advance your career</p>
              </div>
              
              <Card.Body className="p-md-5 p-4">
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">                
                        <Form.Control
                          type="text"
                          name="fullName"
                          placeholder="Full Name"
                          value={formData.fullName}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        />
                        <Form.Label className="form-label-custom">Full Name</Form.Label>
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                      
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Email Address"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        />
                        <Form.Label className="form-label-custom">Email Address</Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                      
                        <Form.Control
                          type="tel"
                          name="phone"
                          placeholder="Phone Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        />
                        <Form.Label className="form-label-custom">Phone Number</Form.Label>
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                      
                        <Form.Select
                          name="graduationYear"
                          value={formData.graduationYear}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        >
                          <option value="">Select Year</option>
                          {yearOptions.map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </Form.Select>
                        <Form.Label className="form-label-custom">School/Graduation Year</Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                      
                        <Form.Control
                          type="text"
                          name="college"
                          placeholder="School/College/Institute & University"
                          value={formData.college}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        />
                        <Form.Label className="form-label-custom">College/University</Form.Label>
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                      
                        <Form.Control
                          name="education"
                          value={formData.education}
                          onChange={handleChange}
                          required
                          placeholder="Academic Background"
                          className="form-control-custom"
                        >
                        
                        </Form.Control>
                        <Form.Label className="form-label-custom">Educational Background</Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                      
                        <Form.Select
                          name="selectedCourse"
                          value={formData.selectedCourse}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        >
                          <option value="">Select Course</option>
                          {courses.map(course => (
                            <option key={course.id} value={course.id}>{course.name}</option>
                          ))}
                        </Form.Select>
                        <Form.Label className="form-label-custom">Course Selection</Form.Label>
                     
                      <p className='text-secondary' style={{fontSize:'0.8rem'}} ><strong>Note:- </strong >Selecting Course/Training for IIT-JEE (Mains & Advance) NEET - (UG & PG), IIT-JAM, GATE and Other Entrance exams, <small className=' text-danger fw-bold' ><b> (Exclude Abroad Exams)</b></small> We Recommend long term for 1 Year/2year sessions for Better performance for STEM Education Systems </p>
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <Form.Group className="form-group-custom mb-4">
                        
                        <Form.Select
                          name="courseDuration"
                          value={formData.courseDuration}
                          onChange={handleChange}
                          required
                          className="form-control-custom"
                        >
                          <option value="">Select Duration</option>
                          {durations.map(duration => (
                            <option key={duration} value={duration}>{duration}</option>
                          ))}
                        </Form.Select>
                        <Form.Label className="form-label-custom">Course Duration</Form.Label>
                        <p className='text-secondary' style={{fontSize:'0.8rem'}} ><strong>Note:- </strong > For Entrance Exams we recommend 1 Year Training Duration </p>

                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Form.Group className="mb-4 custom-checkbox-container">
                    <Form.Check
                      type="checkbox"
                      id="internshipInterest"
                      name="internshipInterest"
                      checked={formData.internshipInterest}
                      onChange={handleChange}
                      required
                      label={
                        <span className="custom-checkbox-label ">
                          <FaBriefcase className="checkbox-icon me-3" />
                          Interested in Internship opportunities
                        </span>
                      }
                      className="custom-checkbox m-3 "
                    />
                  </Form.Group>
                  
                  <Form.Group className="form-group-custom mb-4">
                    <Form.Control
                      as="textarea"
                      name="additionalNotes"
                      placeholder="Any Questions Regarding about the Course / Program"
                      value={formData.additionalNotes}
                      onChange={handleChange}
                      className="form-control-custom textarea-custom"
                      rows={5}
                    />
                    <Form.Label className="form-label-custom">Additional Questions</Form.Label>
                  </Form.Group>
                  
                  <div className="text-center mt-5">
                    <Button 
                      type="submit" 
                      className="submit-button"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Processing...
                        </>
                      ) : (
                        <>
                          <FaPaperPlane className="me-2" />
                          Submit Application
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
              
              <div className="card-footer-custom">
                <p className="mb-0">Have questions? Contact our admissions team at <strong>olewinacademy@gmail.com</strong></p>
                <hr/>

        
            
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdmissionForm;






